module.exports = __webpack_public_path__ + "static/CTA-3df8faa6026aefb58670abc3c46ce4d4.png";